export default {
  nav: {
    home: "Home", about: "About Us", services: "Services", countries: "Countries",
    why: "Why Choose Us", stories: "Success Stories", faq: "FAQ", blog: "Blog", contact: "Contact",
    consultation: "FREE CONSULTATION", call: "CALL NOW", whatsapp: "WHATSAPP",
  },
  hero: {
    eyebrow: "IMMIGRATION & VISA CONSULTANCY — PUNJAB, INDIA",
    title1: "YOUR JOURNEY", title2: "STARTS HERE",
    sub: "Professional Immigration & Visa Assistance for Your Global Future",
    desc: "Explore international opportunities with professional guidance for work permits, visitor visas, immigration documentation and application assistance.",
    cta1: "GET FREE CONSULTATION", cta2: "CHECK YOUR ELIGIBILITY",
    trust: ["Professional Guidance", "Personalized Assistance", "Transparent Process"],
  },
  enquiry: {
    eyebrow: "FREE CONSULTATION",
    title: "START YOUR VISA JOURNEY TODAY",
    desc: "Share a few details and our team will reach out to discuss your goals and the way forward.",
    name: "Full Name", phone: "Phone Number", email: "Email Address", city: "City",
    visaType: "Visa Type", country: "Preferred Country", message: "Message",
    submit: "SUBMIT ENQUIRY", submitting: "SUBMITTING...",
    successTitle: "Thank you for your enquiry.",
    successText: "Your details have been received by THE TRIP WORLD. Mr. Dheeraj Kataria's team will contact you shortly to schedule your free consultation.",
    another: "SUBMIT ANOTHER ENQUIRY",
  },
  about: {
    eyebrow: "01 — WHO WE ARE",
    title1: "YOUR JOURNEY.", title2: "OUR GUIDANCE.",
    p1: "THE TRIP WORLD is a professional immigration and visa consultancy based in Ahmadgarh, Punjab. We work with individuals and families exploring international travel, work, study and immigration opportunities.",
    p2: "Our team provides personalized consultation, documentation guidance and application assistance — built on honest advice, organized processes and clear communication at every step.",
    quote: "Every journey begins with the right guidance. Our role is to make your application process clear, organized and stress-free.",
    founder: "MR. DHEERAJ KATARIA", founderRole: "FOUNDER, THE TRIP WORLD",
    learnMore: "LEARN MORE",
  },
  services: {
    eyebrow: "02 — WHAT WE DO", title: "OUR SERVICES",
    desc: "Comprehensive visa and immigration assistance, tailored to your destination and goals.",
    learnMore: "LEARN MORE",
  },
  countries: {
    eyebrow: "03 — DESTINATIONS", title: "EXPLORE YOUR GLOBAL DESTINATION",
    desc: "From Canada to the UAE, discover the pathways we can help you prepare for.",
    explore: "EXPLORE",
  },
  why: {
    eyebrow: "04 — THE DIFFERENCE", title: "WHY CHOOSE THE TRIP WORLD?",
    desc: "A consultancy experience built on honesty, structure and genuine client care.",
    items: [
      { title: "PERSONALIZED GUIDANCE", text: "Guidance based on each applicant's circumstances, goals and travel history." },
      { title: "DOCUMENTATION SUPPORT", text: "Professional assistance with organising application documents." },
      { title: "TRANSPARENT COMMUNICATION", text: "Clear information about requirements and application steps." },
      { title: "PROFESSIONAL APPROACH", text: "A structured and organised consultation process from start to finish." },
      { title: "END-TO-END ASSISTANCE", text: "Support throughout the relevant stages of the application." },
      { title: "CLIENT FOCUSED", text: "A consultation experience designed around each applicant's goals." },
    ],
  },
  process: {
    eyebrow: "05 — HOW IT WORKS", title: "A CLEAR PATH FORWARD",
    desc: "Four structured steps from first conversation to application support.",
    items: [
      { title: "CONSULTATION", text: "Discuss your travel or immigration goals with our team." },
      { title: "PROFILE & DOCUMENT REVIEW", text: "Review basic information and documentation requirements." },
      { title: "APPLICATION PREPARATION", text: "Prepare and organise the required documents." },
      { title: "APPLICATION SUPPORT", text: "Guidance through the applicable application process." },
    ],
  },
  eligibility: {
    eyebrow: "06 — ELIGIBILITY", title: "CHECK YOUR VISA ELIGIBILITY",
    desc: "Tell us about your profile and goals — our team will review your details and guide you on the most suitable next steps.",
    name: "Name", age: "Age", phone: "Phone", email: "Email", education: "Education",
    occupation: "Occupation", experience: "Work Experience", country: "Preferred Country",
    visaType: "Visa Type", english: "IELTS / PTE Status", message: "Message (optional)",
    submit: "CHECK ELIGIBILITY", submitting: "CHECKING...",
    disclaimer: "This is a preliminary assessment only. Final visa decisions are made by the relevant immigration authority and eligibility does not guarantee visa approval.",
    successTitle: "Profile received.",
    successText: "Thank you. Our team will review your details and contact you to discuss your eligibility and next steps.",
  },
  stories: {
    eyebrow: "07 — SUCCESS STORIES", title: "JOURNEYS WE'VE GUIDED",
    desc: "Genuine experiences from clients who trusted The Trip World with their applications.",
    placeholderTitle: "Real stories, coming soon.",
    placeholderText: "We publish only genuine client experiences — with real names, destinations and visa categories. As our clients share their journeys, their stories will appear here.",
  },
  stats: {
    clients: "Clients Assisted", applications: "Applications Supported",
    destinations: "Destinations", years: "Years of Experience",
  },
  docs: {
    eyebrow: "08 — BE PREPARED", title: "DOCUMENTS YOU MAY NEED",
    desc: "A general overview of documents commonly involved in visa applications.",
    note: "Requirements vary according to country, visa category and individual circumstances.",
    items: [
      { title: "Passport", text: "Valid passport with sufficient validity and blank pages." },
      { title: "Photographs", text: "Recent photographs meeting the destination's specifications." },
      { title: "Financial Documents", text: "Bank statements and proof of funds as applicable." },
      { title: "Educational Documents", text: "Degrees, diplomas and academic transcripts." },
      { title: "Employment Documents", text: "Experience letters, offers and employer records." },
      { title: "Travel History", text: "Previous visas and international travel records." },
      { title: "Invitation / Supporting Documents", text: "Invitations, sponsorship or enrolment letters." },
      { title: "Other Supporting Documents", text: "Category-specific documents as required." },
    ],
  },
  faq: {
    eyebrow: "09 — QUESTIONS", title: "FREQUENTLY ASKED QUESTIONS",
    desc: "Straight answers to the questions we hear most often.",
    items: [
      { q: "What visa services does The Trip World provide?", a: "We provide consultation and application assistance for work permit visas, visitor visas, student visas, family/spouse visas, business visas, and complete documentation support for international travel and immigration." },
      { q: "How do I start my visa application?", a: "Start with a free consultation. Share your travel or immigration goal, and our team will review your profile, explain the general requirements, and outline the steps and documents relevant to your situation." },
      { q: "What documents are generally required?", a: "Common documents include a valid passport, photographs, financial records, educational and employment documents, and travel history. Exact requirements vary by country, visa category and individual circumstances." },
      { q: "How long does visa processing take?", a: "Processing times are decided by the relevant immigration authority and vary by country, visa category and application volume. We share current indicative timelines during your consultation." },
      { q: "Can you help me prepare my documents?", a: "Yes. Documentation and application assistance is one of our core services. We help you organise, review and prepare a clear, complete application file." },
      { q: "Can you check my eligibility?", a: "Yes. Use our online eligibility checker or book a consultation. Please note this is a preliminary assessment only — final eligibility and visa decisions are made by the relevant immigration authority." },
      { q: "Which countries do you assist with?", a: "We assist with applications for Canada, the United Kingdom, Australia, the USA, New Zealand, Europe (Schengen), Germany, France and the UAE, with support for additional destinations on request." },
      { q: "Does The Trip World guarantee visa approval?", a: "No. Visa decisions are made solely by the relevant immigration authority, and no consultancy can guarantee approval. We provide honest guidance and professional application assistance to present your case clearly." },
    ],
  },
  blog: {
    eyebrow: "10 — THE JOURNAL", title: "INSIGHTS & UPDATES",
    desc: "Guides, documentation advice and travel insights from our consultancy desk.",
    viewAll: "VIEW ALL ARTICLES", read: "READ ARTICLE",
    emptyTitle: "Articles coming soon.",
    emptyText: "Our journal will feature visa guidance, documentation tips and destination insights — published by our own team.",
  },
  contact: {
    eyebrow: "11 — GET IN TOUCH", title: "LET'S START YOUR JOURNEY",
    desc: "Visit us, call us, or send a message — your free consultation is one step away.",
    phone: "Phone", emailLabel: "Email", website: "Website", location: "Location",
    call: "CALL", whatsapp: "WHATSAPP", emailBtn: "EMAIL",
    formName: "Full Name", formPhone: "Phone Number", formEmail: "Email Address",
    formMessage: "How can we help you?", submit: "SEND MESSAGE", sending: "SENDING...",
    successTitle: "Message received.",
    successText: "Thank you for reaching out. Our team will respond to you as soon as possible.",
    another: "SEND ANOTHER MESSAGE",
  },
  cta: {
    title: "READY TO BEGIN?", heading: "YOUR JOURNEY STARTS HERE",
    text: "Book a free consultation with The Trip World and get clear, honest guidance for your visa journey.",
    button: "GET FREE CONSULTATION",
  },
  footer: {
    blurb: "Professional immigration and visa consultancy based in Ahmadgarh, Punjab — guiding your journey toward international work, study and travel opportunities.",
    company: "COMPANY", servicesCol: "SERVICES", quick: "QUICK LINKS", contactCol: "CONTACT",
    eligibility: "Eligibility",
    rights: "All rights reserved.",
    privacy: "Privacy Policy", terms: "Terms & Conditions", disclaimerLink: "Disclaimer",
  },
  notFound: {
    eyebrow: "OFF COURSE", title: "This destination doesn't exist.",
    text: "The page you're looking for has moved or never existed. Let us guide you back on track.",
    button: "BACK TO HOME",
  },
};
